export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_FORTNOXACCOUNT",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_FORTNOXACCOUNT",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_FORTNOXACCOUNT",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_FORTNOXACCOUNT",
  DESTROY_FORM: "DESTROY_FORM_FORTNOXACCOUNT",
  SET_FORM_ERROR: "SET_FORM_ERROR_FORTNOXACCOUNT",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_FORTNOXACCOUNT",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_FORTNOXACCOUNT",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_FORTNOXACCOUNT",
  RESET_STATE: "RESET_STATE_FORTNOXACCOUNT",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_FORTNOXACCOUNT",
  REMOVE_OBJECT: "REMOVE_OBJECT_FORTNOXACCOUNT",
  SET_EXPECTED_INVOICE_STAT: "SET_EXPECTED_INVOICE_STAT_FORTNOXACCOUNT",
  CLEAR_FETCHED: "CLEAR_FETCHED_FORTNOXACCOUNT",

  LIST_URL: "/accounting/fortnox/fortnoxaccount/list/",
  POST_URL: "/accounting/fortnox/fortnoxaccount/",
  PATCH_URL: "/accounting/fortnox/fortnoxaccount/",
  GET_URL: "/accounting/fortnox/fortnoxaccount/",

  STORE_NAME: "fortnoxAccount",
};
